import { FormikHelpers } from "formik";
import { useCreateUsedBy } from "./api/createUsedBy";
import UsedByTypeForm from "./UsedByForm";


const CreateUsedBy = ({handleCloseModal}: CreateUsedByProps)  => {
  const createUsedByMutation = useCreateUsedBy({data: {}});

  const initialValues: IPostNewUsedBy = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewUsedBy, { setSubmitting }: FormikHelpers<IPostNewUsedBy>): Promise<void> => {
    try {
      await createUsedByMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <UsedByTypeForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateUsedByProps {
  handleCloseModal: () => void;
}

export default CreateUsedBy;